// extracted by mini-css-extract-plugin
export default {"section":"yNSX","header":"TaFU","header-content":"Tnl2","headerContent":"Tnl2","title":"n3Xs","description":"wRdZ","expand-button":"anBu","expandButton":"anBu","content":"twWH"};